import { Injectable } from "@angular/core";

import { DataService } from "../shared/services/data.service";
import { ConfigurationService } from "../shared/services/configuration.service";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SsoDTO } from "../shared/dto-models/ssoDTO.model";
import { SsoCommand } from "../shared/models/ssoCommand";

@Injectable()
export class SsoService {
  private ePermitsUrl = "";
  private identityUrl = "";
  private userApiUrl = "";

  constructor(
    private service: DataService,
    private configurationService: ConfigurationService,
  ) {
    if (this.configurationService.isReady) {
      this.ePermitsUrl = this.configurationService.serverSettings.ePermitsUrl;
      this.identityUrl = this.configurationService.serverSettings.identityUrl;
      this.userApiUrl =
        this.configurationService.serverSettings.userSettingsApiUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe((x) => {
        this.identityUrl = x?.identityUrl;
        this.userApiUrl = x?.userSettingsApiUrl;
        return (this.ePermitsUrl = x?.ePermitsUrl);
      });
    }
  }

  get(systemId: number): Observable<SsoDTO> {
    if (!this.ePermitsUrl) {
      return;
    }
    const url = `${this.userApiUrl}/api/v1/sso?systemId=${systemId}`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  save(command: SsoCommand): Observable<true> {
    const url = `${this.userApiUrl}/api/v1/sso/save`;

    return this.service.postWithId(url, command).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  downloadPublicCert() {
    const url = `${this.userApiUrl}/api/v1/sso/download`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  downloadNextPublicCert() {
    const url = `${this.userApiUrl}/api/v1/sso/download-next`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  logout(issuer: string): Observable<boolean> {
    const url = `${
      this.identityUrl
    }/Saml/InitiateSingleLogout?issuer=${encodeURIComponent(issuer)}`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }
}
